export default "__VITE_ASSET__DxvjHpp8__"